module.exports = __webpack_public_path__ + "static/assets/2834bea0cc1c121d71869d7e3b08de99.png";